import { toStandalonePrintHtml } from './printDocument.js';

// Capture in a separate document: application-wide !important theme rules must
// not recolor the invoice, nor should template styles leak into the application.
export const createIsolatedPrintSurface = (html, title) => {
    const content = toStandalonePrintHtml(html, title);
    const frame = document.createElement('iframe');
    frame.title = 'تحضير نسخة الطباعة';
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('sandbox', 'allow-same-origin');
    frame.setAttribute('data-testid', 'isolated-print-surface');
    Object.assign(frame.style, { position: 'fixed', left: '-10000px', top: '0', width: '794px', height: '1123px', border: '0', pointerEvents: 'none' });
    // The host app applies iframe { max-width: 100% } on mobile. Keep the
    // capture viewport A4-sized even while the surrounding UI is 390px wide.
    for (const property of ['width', 'min-width', 'max-width']) frame.style.setProperty(property, '794px', 'important');
    document.body.appendChild(frame);
    try {
        const doc = frame.contentDocument;
        if (!doc) throw new Error('تعذر إنشاء مساحة طباعة مستقلة');
        doc.open(); doc.write(content); doc.close();
        // Screen-only outer page padding belongs to the template preview, not
        // the captured A4 page (the template's print rules remove it as well).
        doc.body.style.setProperty('padding', '0', 'important');
        doc.body.style.setProperty('margin', '0', 'important');
        return { element: doc.body, cleanup: () => frame.remove() };
    } catch (error) {
        frame.remove();
        throw error;
    }
};
